import { render, staticRenderFns } from "./certificate_fileupload.vue?vue&type=template&id=37650508&"
import script from "./certificate_fileupload.vue?vue&type=script&lang=js&"
export * from "./certificate_fileupload.vue?vue&type=script&lang=js&"
import style0 from "./certificate_fileupload.vue?vue&type=style&index=0&id=37650508&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports